import { getMessages } from '../../../../../../store/constants';

export const CHATS_TITLE = getMessages().getText( 'board_settings.chats.header');
export const CHATS_BUTTON = getMessages().getText( 'board_settings.chats.button');
